//@ts-ignore
// @ts-nocheck
import { flow, getEnv, getParent, getSnapshot, types } from "mobx-state-tree";
import {
  ACCEPTED_RESPONSE,
  ACCEPT_ACTION,
  BOOK_LESSONS_ACTION,
  DECLINED_RESPONSE,
  NO_RESPONSE,
  PENDING_RESPONSE,
  SUBMIT_FEEDBACK_ACTION,
} from "./utils/request";
import SplitRequestStore from "./splitRequest";
import { TutorResponseStore } from "./tutor";

const Agent = types.model("Agent", {
  title: types.optional(types.string, ""),
  name: types.optional(types.string, ""),
  phone_number: types.optional(types.string, ""),
  email: types.optional(types.string, ""),
  image: types.optional(types.string, ""),
  slack_id: types.optional(types.string, ""),
});
const RequestDetailModel = types.model("RequestDetailModel", {
  budget: types.optional(types.number, 0),
  hourlyRate: types.optional(types.number, 0),
});

export const ServerRequestInfo = types
  .model("ServerRequestInfo", {
    created: types.optional(types.string, ""),
    modified: types.optional(types.string, ""),
    status: types.optional(types.string, ""),
    tutorRequestInfo: types.maybe(SplitRequestStore),
    tutorResponseInfo: types.optional(TutorResponseStore, {}),
    agent: types.maybe(Agent),
    loading: types.optional(types.boolean, false),
    rawRequest: types.maybe(RequestDetailModel, {}),
  })
  .views((self) => {
    return {
      get bookingInfo() {
        if (self.rawRequest?.budget) {
          return {
            hourlyRate: self.rawRequest.hourlyRate,
            tutorEarnings: self.rawRequest.budget,
            earningPercentage: 70,
            firstBookingDiscount: 0,
            transportFare: 0,
            distance: 0,
            withholdingTax: 5,
            currency: "₦",
            priceIsFetched: true,
          };
        }
        let bE = self.tutorRequestInfo?.tutorBaseEarning;
        return bE?.subject
          ? {
              hourlyRate:
                self.tutorRequestInfo.tutorBaseEarning.subject.hourlyRate,
              tutorEarnings: self.tutorRequestInfo.tutorBaseEarning.lessonFee,
              earningPercentage:
                self.tutorRequestInfo.tutorBaseEarning.level == "premium"
                  ? 75
                  : 70,
              firstBookingDiscount:
                self.tutorRequestInfo.rawPaymentInfo.firstBookingDiscount,
              transportFare: self.tutorRequestInfo.rawPaymentInfo.transportFare,
              distance: self.tutorRequestInfo.rawPaymentInfo.distance || 0,
              withholdingTax: 5,
              currency: "₦",
              priceIsFetched: true,
            }
          : {};
      },
      get hasAccepted() {
        return self.tutorResponseInfo.status == ACCEPT_ACTION;
      },
      get isPending() {
        return self.tutorResponseInfo.status == PENDING_RESPONSE;
      },
      get showBreakdown() {
        return this.hasAccepted || this.isPending;
      },
      get noResponse() {
        return self.tutorResponseInfo.status == NO_RESPONSE;
      },
      get declined() {
        return self.tutorResponseInfo.status == DECLINED_RESPONSE;
      },
      get tutorResponse() {
        return self.tutorResponseInfo;
      },
      get tutorInfo() {
        return getSnapshot(self.tutorRequestInfo.tutorData);
      },
    };
  })
  .actions((self) => {
    let { adapter } = getEnv(self);
    let parent = getParent(self, 1);
    const updateJobStatus = flow(function* acceptJob(response, actionType) {
      const dateSubmitted = new Date().toISOString();
      self.loading = true;
      try {
        let allowedState = [
          PENDING_RESPONSE,
          ACCEPTED_RESPONSE,
          DECLINED_RESPONSE,
        ];
        let defaultResponse = {
          status: self.tutorResponseInfo.status,
          dateSubmitted: self.tutorResponseInfo.dateSubmitted,
          responseTime: self.tutorResponseInfo.responseTime,
        };

        if (allowedState.includes(actionType)) {
          defaultResponse = {
            ...defaultResponse,
            ...response,
            dateSubmitted,
            status: actionType,
          };
        }
        if (actionType == SUBMIT_FEEDBACK_ACTION) {
          defaultResponse = {
            ...defaultResponse,
            callFeedback: {
              callSummary: response.callSummary,
              startDate: response.startDate,
            },
          };
        }
        if (actionType == BOOK_LESSONS_ACTION) {
          const bookingDuration = yield adapter.bookLessons(
            parent.slug,
            response.sessions,
          );
          defaultResponse = {
            ...defaultResponse,
            bookingDuration,
          };
        }
        const tutorResponse = {
          ...defaultResponse,
        };
        let stagesToSave = self.tutorResponseInfo.updateBookingStage(
          actionType,
          dateSubmitted,
          true,
        );
        yield adapter.updateTutorResponse(
          {
            ...self.tutorResponseInfo.fullData,
            ...tutorResponse,
            bookingStage: {
              ...stagesToSave,
            },
          },
          parent.slug,
          self.tutorInfo.userId,
          { ...self.agent },
        );
        self.tutorResponseInfo.updateSelf(tutorResponse);
        self.tutorResponseInfo.updateBookingStage(actionType, dateSubmitted);
        console.log(getSnapshot(self.tutorResponseInfo));
        self.loading = false;
      } catch (error) {
        self.loading = false;
        console.error(error);
        throw error;
      }
    });

    return {
      updateJobStatus,
    };
  });

export default ServerRequestInfo;
